module.exports = __webpack_public_path__ + "static/img/cooperation_process.6b5c77b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/cooperation_process.png
// module id = CopE
// module chunks = 1